import { createAsyncThunk } from '@reduxjs/toolkit';
import LanguagesApi from '@infrastructure/languages-api';
import { getErrorPayload } from '@application/helpers/api-helper';
import VDKEventLanguagesApi from '@infrastructure/vdk-event-languages-api';
export const getAllLanguagesAsync = createAsyncThunk('languages/getAll', async (_, { rejectWithValue }) => {
    try {
        const response = await LanguagesApi.getAllLanguages();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventLanguagesByEventIdAsync = createAsyncThunk('languages/getByEventId', async (eventId, { rejectWithValue }) => {
    try {
        const response = await VDKEventLanguagesApi.getLanguagesForEvent(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
